import React from 'react';
import { createOpenAIModalCommand } from '../../../pm-plugins/decoration/actions';
import { FloatingAiButton } from './ask-ai-button';
import { FLOATING_AI_BUTTON_SIZE } from './styles';
export const AskAIButtonWrapper = props => {
  var _contentArea$offsetLe, _contentArea$offsetLe2;
  const {
    editorView,
    selection,
    editorPluginAIProvider,
    showButton,
    aiGlobalOptIn,
    appearance
  } = props;
  const onButtonClick = React.useCallback(() => {
    const {
      state,
      dispatch
    } = editorView;
    const configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
    const openAIModalCommand = createOpenAIModalCommand({
      state,
      configItem,
      lastTriggeredFrom: 'floatingAiButton',
      aiGlobalOptIn
    });
    openAIModalCommand(state, dispatch);
  }, [editorView, editorPluginAIProvider, aiGlobalOptIn]);

  // Left positioning of the button
  const contentArea = editorView.dom.closest('.ak-editor-content-area');
  const [positionLeft, setUpdatedPositionLeft] = React.useState((_contentArea$offsetLe = contentArea === null || contentArea === void 0 ? void 0 : contentArea.offsetLeft) !== null && _contentArea$offsetLe !== void 0 ? _contentArea$offsetLe : 0);
  const [editorLeft, setEditorLeft] = React.useState((_contentArea$offsetLe2 = contentArea === null || contentArea === void 0 ? void 0 : contentArea.offsetLeft) !== null && _contentArea$offsetLe2 !== void 0 ? _contentArea$offsetLe2 : 0);

  // Handle resizing of the content area
  React.useEffect(() => {
    if (!editorView) {
      return;
    }
    const scrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
    const resizeObserver = new ResizeObserver(() => {
      var _editorView$dom2;
      if (appearance === 'tip-tap-menu') {
        var _editorView$dom;
        setEditorLeft(((_editorView$dom = editorView.dom) === null || _editorView$dom === void 0 ? void 0 : _editorView$dom.offsetLeft) || 0);
        return;
      }
      setUpdatedPositionLeft(((_editorView$dom2 = editorView.dom) === null || _editorView$dom2 === void 0 ? void 0 : _editorView$dom2.offsetLeft) - FLOATING_AI_BUTTON_SIZE - 8 || 0);
    });
    resizeObserver.observe(scrollParent || editorView.dom);
    if (contentArea) {
      resizeObserver.observe(contentArea);
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [editorView, appearance, contentArea]);
  const domElement = editorView.domAtPos(selection.from).node;
  // we've landed on text instead of a paragraph/heading node
  const nodeElement = domElement.nodeName === '#text' ? domElement.parentElement : domElement;
  if (nodeElement === null) {
    return null;
  }
  let shouldShowAskAIButton = showButton;
  let buttonLeft = positionLeft;
  if (appearance === 'tip-tap-menu') {
    const buttonOffsetPx = 10; // button offset from the cursor
    buttonLeft = editorLeft + buttonOffsetPx;
    // check additional conditions to display tiptap menu
    // need also check for any content not applied yet
    // e.g. with quickinsert we can have text overlapping with button while no content insterted

    // Check if editor page placeholder is present
    // Note: this doesn't check for AI persistent placeholder
    const placeholderPluginKeyName = 'placeholderPlugin$';
    const placeholderPlugin = editorView.state.plugins.find(plugin => plugin.key === placeholderPluginKeyName);
    const placeholderPluginState = placeholderPlugin === null || placeholderPlugin === void 0 ? void 0 : placeholderPlugin.getState(editorView.state);
    shouldShowAskAIButton = editorView.state.selection.$from.depth <= 1 && editorView.hasFocus() && editorView.state.selection.$from.parent.isTextblock && editorView.state.selection.$from.parent.content.size === 0 && !Boolean(placeholderPluginState === null || placeholderPluginState === void 0 ? void 0 : placeholderPluginState.hasPlaceholder);
  }

  // don't show floating ai button if there is not enough space on left
  if (shouldShowAskAIButton && buttonLeft >= 0) {
    return /*#__PURE__*/React.createElement(FloatingAiButton, {
      positionTop: nodeElement.offsetTop,
      positionLeft: buttonLeft,
      contentHeight: nodeElement.getBoundingClientRect().height,
      onClick: onButtonClick
    });
  }
  return null;
};